import BusinessCoachInboxAsset from '/asset/image/inbox-business-coach.png';
import BusinessLeaderInboxAsset from '/asset/image/inbox-business-leader.png';
import CoachInboxAsset from '/asset/image/inbox-coach.png';
import {BUSINESS_COACH, BUSINESS_LEADER, COACH} from '/enum/competency.enum';

type Competency = typeof COACH | typeof BUSINESS_COACH | typeof BUSINESS_LEADER;
interface GetInboxAssetProps {
  currentUserCompetency: Competency;
}

export function getInboxAsset({currentUserCompetency}: GetInboxAssetProps) {
  if (currentUserCompetency === COACH) {
    return CoachInboxAsset;
  } else if (currentUserCompetency === BUSINESS_COACH) {
    return BusinessCoachInboxAsset;
  } else if (currentUserCompetency === BUSINESS_LEADER) {
    return BusinessLeaderInboxAsset;
  }
  return null;
}
